import { useEffect } from 'react';
import type { BridgeNtState, BridgeSide } from '../games/bridge-nt';
import { useRoom } from '../state/room';
import { type Role, useMentalPokerHand } from './useMentalPokerHand';

export function BridgeDealDriver({board, state, side, role, matchCode, myTurnAllowed}: {board: number; state: BridgeNtState; side: BridgeSide | null; role: Role | null; matchCode: string; myTurnAllowed: boolean}): null {
  const results = useRoom(store => store.mps.get(`${board}:1`) ?? null);
  const context = results?.context;
  const awaiting = state.phase === 'awaiting_hands';
  const provided = side !== null && state.provided[side === 'First' ? 0 : 1];
  const active = awaiting && side !== null && role !== null && role !== 'spectator' && !results?.cheatDetected && !results?.cryptoError;
  useMentalPokerHand({board, hand: 1, role, mySeat: side === 'First' ? 'sb' : side === 'Second' ? 'bb' : null, bridgeSide: side ?? undefined, awaiting: awaiting ? 'bridge' : null, matchCode, engineMyHole: null, engineBoard: [], active});
  useEffect(() => {
    if (!active || provided || !myTurnAllowed || !context || !results?.bridgeHands || !results.bridgeReveal) return;
    const provide = () => {
      const room = useRoom.getState();
      const current = room.mps.get(`${board}:1`);
      if (room.code !== matchCode || room.you !== role || current?.context !== context || current.bridgeReveal?.context !== context || !current.bridgeHands || current.cheatDetected || current.cryptoError) return;
      room.sendMove(board, {provide_hands: {hands: current.bridgeHands, reveal: current.bridgeReveal}});
    };
    provide();
    const timer = setInterval(provide, 2500);
    return () => clearInterval(timer);
  }, [active, provided, myTurnAllowed, context, results?.bridgeHands, results?.bridgeReveal, role, matchCode, board]);
  return null;
}
